import React, { useState } from 'react';
import ModalPopup from '../../../common/ModalPopup';

const LogoDesign = ({ portfolioData, type }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedProject, setSelectedProject] = useState({})
    console.log(portfolioData);
    /*  const handleProjectDetail = (item) => {
         console.log(item)
         setShowModal(true);
         setSelectedProject(item);
     } */
    return (
        <>
            {
                showModal &&
                <ModalPopup onClose={() => { setShowModal(false) }} selectedProject={selectedProject} />
            }

            <table width="100%" cellPadding={10} cellSpacing={10}>

                <tr>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/MoBoo-logo.png" data-lightbox="MoBoo Logo">
                            <img width="100%" src="/images/logodesign/MoBoo-logo.png" />
                        </a>
                    </td>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/bombay-olive.jpg" data-lightbox="Bombay Olive">
                            <img width="100%" src="/images/logodesign/bombay-olive.jpg" />
                        </a>
                    </td>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/ebragger.jpg" data-lightbox="eBragger">
                            <img width="100%" src="/images/logodesign/ebragger.jpg" />
                        </a>
                    </td>
                </tr>
                <tr>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/FMC_logo.jpg" data-lightbox="FMC logo">
                            <img width="100%" src="/images/logodesign/FMC_logo.jpg" />
                        </a>
                    </td>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/tnt-logo.jpg" data-lightbox="TNT logo">
                            <img width="100%" src="/images/logodesign/tnt-logo.jpg" />
                        </a>
                    </td>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/sb-logo.jpg" data-lightbox="Scan Better logo">
                            <img width="100%" src="/images/logodesign/sb-logo.jpg" />
                        </a>
                    </td>

                </tr>
                <tr>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/convergies-logo.jpg" data-lightbox="Convergies logo">
                            <img width="100%" src="/images/logodesign/convergies-logo.jpg" />
                        </a>
                    </td>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/tamada-logo.jpg" data-lightbox="Tamada Media logo">
                            <img width="100%" src="/images/logodesign/tamada-logo.jpg" />
                        </a>
                    </td>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/sms-logo.jpg" data-lightbox="SMS logo">
                            <img width="100%" src="/images/logodesign/sms-logo.jpg" />
                        </a>
                    </td>
                </tr>
                <tr>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/NorthStar_logo3.jpg" data-lightbox="NorthStar Logo">
                            <img width="100%" src="/images/logodesign/NorthStar_logo3.jpg" />
                        </a>
                    </td>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/sacred-love-logo.jpg" data-lightbox="Sacred Love Logo">
                            <img width="100%" src="/images/logodesign/sacred-love-logo.jpg" />
                        </a>
                    </td>
                    <td className="card" width="33%">
                        <a href="/images/logodesign/ganz.jpg" data-lightbox="Ganz Logo">
                            <img width="100%" src="/images/logodesign/ganz.jpg" />
                        </a>
                    </td>
                </tr>
            </table> 

        </>
    )
}
export default LogoDesign;